module.exports = __webpack_public_path__ + "static/media/Weather.845d5f4d.jpg";